import React, { useContext, useEffect, useState } from "react";
import { Alert, Table } from "../../../../layout";
import { IconButton, Tooltip } from "@mui/material";
import { PrintRounded, RemoveRedEyeRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../controls";
import { AppContext } from "../../../../App";
import { action, API, controller } from "../../../../api/api";
import {
  formatDate,
  formatDecimal,
  PrintDiv,
  useFormatPrice,
} from "../../../../hooks/Method";
import PrintReturnReceipt from "./PrintReturnReceipt";

const StockReturns = () => {
  const { setLoader, access } = useContext(AppContext);
  const formatPrice = useFormatPrice();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [receiptData, setReceiptData] = useState({});

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    API(controller.StockReturn + action.GetAllByOrg).get((res) => {
      res && res.status === 200 && setStocks([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (id) => {
    navigate(`/stock_return_form/${id || ""}`);
  };

  const handleView = (id) => {
    navigate(`/view_return_stock/${id}`);
  };

  const handlePrintReceipt = (id) => {
    setLoading(true);
    API(controller.StockReturn + action.GetDetailsById).getById(id, (res) => {
      setLoading(false);
      if (res && res.status === 200 && res.result) {
        setReceiptData({ ...res.result });
        setTimeout(() => {
          PrintDiv("printReturnReceipt");
        }, 500);
      } else setReceiptData({});
    });
  };

  const ActionComp = (val) => (
    <div className="border !border-slate-200 shadow-md rounded-[8px] w-fit flex gap-2 p-[2px]">
      {loading ? (
        "Loading..."
      ) : (
        <>
          <Tooltip title="View">
            <IconButton
              onClick={() => handleView(val.id)}
              size="small"
              color="primary"
              className="ml-[5px] mr-[5px] p-[5px]"
            >
              <RemoveRedEyeRounded className="!text-[18px] m-[2px]" />
            </IconButton>
          </Tooltip>
          {access?.stockReturn?.print && (
            <Tooltip title="Print">
              <IconButton
                onClick={() => handlePrintReceipt(val.id)}
                size="small"
                color="primary"
                className="ml-[5px] mr-[5px] p-[5px]"
              >
                <PrintRounded className="!text-[18px] m-[2px]" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
  const HeaderComp = () =>
    access?.stockReturn?.create && (
      <Button onClick={() => handleAddEdit()}>Add Return</Button>
    );

  return (
    <>
      <div className="hidden" id="printReturnReceipt">
        {receiptData && receiptData.id && (
          <PrintReturnReceipt data={receiptData} />
        )}
      </div>

      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: "Actions" },
          { id: "returnNo", label: "Return No." },
          { id: "splr", label: "Suppler" },
          { id: "qty_amount", label: "Qty | Amount" },
        ]}
        tblData={stocks.map((j) => {
          return {
            ...j,
            returnNo: (
              <div className="pb-[3px] pt-[3px] grid">
                <span>{j.returnNo}</span>
                <span className="text-[12px] font-medium">
                  {j.returnDate && formatDate(j.returnDate)}
                </span>
              </div>
            ),
            splr: (
              <div className="grid">
                <span>{j.supplier?.company}</span>
                <span className={`text-[${j.supplier?.company ? 12 : 16}px]`}>
                  {j.supplier?.splrName}
                </span>
              </div>
            ),
            qty_amount: (
              <div className="flex flex-col w-fit">
                <span className="text-[13px] border-b font-medium">
                  Total Qty: {formatDecimal(j.totalQty, true)}
                </span>
                <span className="text-[13px] font-medium">
                  Total Amount: {formatPrice(j.totalAmount)}
                </span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default StockReturns;
